import { useEffect } from "react";
import { Link } from "react-router-dom";
import { WEBINAR, HOST, COPYRIGHT } from "@/data/content";

const gcalUrl = () => {
  const { title, details, location, startUTC, endUTC } = WEBINAR.calendar;
  const p = new URLSearchParams({ action: "TEMPLATE", text: title, details, location, dates: `${startUTC}/${endUTC}` });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
};

const downloadIcs = () => {
  const { title, details, location, startUTC, endUTC } = WEBINAR.calendar;
  const ics = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Epiphanie Lending//Webinar//EN",
    "BEGIN:VEVENT", `UID:${Date.now()}@epiphanielending.com`,
    `DTSTAMP:${startUTC}`, `DTSTART:${startUTC}`, `DTEND:${endUTC}`,
    `SUMMARY:${title}`, `DESCRIPTION:${details}`, `LOCATION:${location}`,
    "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");
  const url = URL.createObjectURL(new Blob([ics], { type: "text/calendar" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = "boots-first-va-benefit-review.ics";
  a.click();
  URL.revokeObjectURL(url);
};

export default function ThankYou() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="page-root min-h-screen flex items-center justify-center px-6 py-16" data-testid="thank-you-page">
      <div className="grain-overlay" aria-hidden="true" />
      <div className="glass-card max-w-xl w-full p-8 sm:p-12 text-center">
        <div className="w-20 h-20 mx-auto rounded-full bg-[#D9622B] flex items-center justify-center text-black text-4xl font-black">✓</div>
        <p className="mt-6 font-mono text-[10px] tracking-[0.3em] text-[#D9622B]">REGISTRATION CONFIRMED</p>
        <h1 className="mt-3 text-4xl sm:text-5xl font-black uppercase leading-none" style={{ fontFamily: "'Big Shoulders Display', sans-serif" }}>
          Your Seat Is <span className="text-[#D9622B]">Reserved.</span>
        </h1>
        <p className="mt-5 text-sm text-white/55 leading-relaxed">
          Check your email for confirmation and access details for the <strong className="text-white/80">Boots-First VA Benefit Review</strong>. We'll send a reminder before we go live.
        </p>
        <div className="mt-6 border border-white/10 bg-white/[0.03] p-5 text-left">
          <p className="font-mono text-[10px] tracking-[0.25em] text-white/30">EVENT DETAILS</p>
          <p className="mt-2 text-sm font-bold text-[#F0ECE4]">{WEBINAR.dateLine.replace("📅 ", "")}</p>
          <p className="mt-1 text-[13px] text-white/45">{WEBINAR.duration} · Live online · Hosted by {HOST.name}</p>
        </div>
        <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
          <a href={gcalUrl()} target="_blank" rel="noopener noreferrer" data-testid="add-google-calendar-btn"
            className="btn-primary text-black font-black text-sm tracking-[0.1em] px-6 py-4 inline-block">
            + ADD TO GOOGLE CALENDAR
          </a>
          <button onClick={downloadIcs} data-testid="download-ics-btn"
            className="btn-outline border border-[#D9622B] text-[#D9622B] font-bold text-sm tracking-[0.1em] px-6 py-4">
            ⬇ APPLE / OUTLOOK (.ICS)
          </button>
        </div>
        <p className="mt-6 text-[11px] text-white/25">Free educational event · No obligation · No hard credit pull required to attend</p>
        <Link to="/" data-testid="thankyou-back-link" className="mt-6 inline-block font-mono text-[11px] tracking-[0.2em] text-white/40 hover:text-white/70 transition-colors">
          ← BACK TO EVENT PAGE
        </Link>
        <p className="mt-8 font-mono text-[9px] text-white/[0.15]">{COPYRIGHT}</p>
      </div>
    </div>
  );
}
